import { styled } from "@mui/material";
import { StaticDatePicker as DatePicker } from '@mui/x-date-pickers/StaticDatePicker';
import { toProperDate } from 'utils';

import DatePickerContainer from './DatePickerContainer';

const MuiStaticDatePicker = styled(DatePicker)(({theme}) => ({
  "& .MuiIconButton-sizeSmall": {
    display: 'none' // [GM]: remove collapse arrow button (visible instructions to open month + year)
  },
  '.MuiPickersArrowSwitcher-button': {
    transform: 'inherit !important',
    '&:hover,:target': {
      background: 'var(--mui-palette-secondary-main)'
    }
   }
}));

export const StaticDatePicker = (props) => {

  return (
    <DatePickerContainer aria-labelledby={props.labelledBy}>
      <MuiStaticDatePicker
        disablePast={true}
        shouldDisableDate={(date) => !!props?.dates && !props?.dates[toProperDate(date)]}
        displayStaticWrapperAs='desktop'
        views={['day']}
        {...props}
      />
    </DatePickerContainer>
  );
}

export default StaticDatePicker;